module.exports = __webpack_public_path__ + "img/curas5.ca633052.jpg";